import React from 'react';
import {
    Button,
} from '@paretogroup/tess';

import { useCampaignFilterInterface } from '../../interface';
import { Footer, useStyles } from './filter-drawer-footer.styles';
import {
    FILTER_DRAWER_FOOTER_AUTO_TEST_ID,
    FILTER_DRAWER_FOOTER_TEST_ID,
    FILTER_DRAWER_FOOTER_TEXTS,
} from './filter-drawer.constants';

export const FilterDrawerFooter = () => {
    const {
        onClickClear, openSaveModal, isSaveFilterDisabled, isClearRulesDisabled,
    } = useCampaignFilterInterface();

    const classes = useStyles();

    return (
        <Footer>
            <Button
                className={classes.saveButton}
                disabled={isSaveFilterDisabled}
                onClick={openSaveModal}
                data-testid={FILTER_DRAWER_FOOTER_TEST_ID.SAVE}
                data-auto-testid={FILTER_DRAWER_FOOTER_AUTO_TEST_ID.SAVE}
            >
                {FILTER_DRAWER_FOOTER_TEXTS.SAVE}
            </Button>
            <Button
                className={classes.clearButton}
                disabled={isClearRulesDisabled}
                onClick={onClickClear}
                data-testid={FILTER_DRAWER_FOOTER_TEST_ID.CLEAR}
                data-auto-testid={FILTER_DRAWER_FOOTER_AUTO_TEST_ID.CLEAR}
            >
                {FILTER_DRAWER_FOOTER_TEXTS.CLEAR}
            </Button>
        </Footer>
    );
};
